import { UserCreationComponent } from './../user-creation/user-creation.component';
import { UsersService } from './../services/users.service';
import { DataTableUser } from './../interfaces/DataTableUser';
import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserModificationComponent } from '../user-modification/user-modification.component';
import { UserInfosComponent } from '../user-infos/user-infos.component';
import { fromEvent } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { UserPaymentComponent } from '../user-payment/user-payment.component';
@Component({
selector: 'app-users',
templateUrl: './users.component.html',
styleUrls: ['./users.component.scss'],
})

export class UsersComponent implements OnInit, AfterViewInit {

	@BlockUI() blockUI: NgBlockUI;
	@Input() role: string;
	@ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;
	@ViewChild('search', { static: false }) search: any;

	ColumnMode = ColumnMode;
	public columns: Array<object> = [
		{ prop: 'fullName', name: 'Nom <i class="fa fa-sort sort-icon"></i></span>' },
		{ prop: 'email', name: 'Email <i class="fa fa-sort sort-icon"></i></span>' },
		{ prop: 'network', name: 'Réseau <i class="fa fa-sort sort-icon"></i></span>' },
		{ prop: 'btn_show', name: "Informations de l’utilisateur" },
		// { prop: 'btn_pwd', name: 'Gestion du mot de passe' },
		{ prop: 'btn_acc', name: 'Gestion du compte' }
	];

	dataTableUser: Array<DataTableUser> = [];
	dataTableUserDisplay: Array<DataTableUser> = [];
	public temp: Array<DataTableUser> = [];
	public rows: Array<DataTableUser> = [];
	searchField: string;
	pageSize: number = 10;
	currentPage: number = 1;
	collectionSize: number;
	countDataLength: number;

	// not used, maybe for v2
	network: string = '';


	empty_msgFr = {
		'emptyMessage': ''
	  };

	constructor(
		private toastrService: ToastrService,
		private usersService: UsersService,
		private usersModalService: NgbModal,
		private translate: TranslateService
	) {
		usersService.head2List.subscribe(
			(res) => {
				this.getAllUsers();
			}
		)

	  translate.get('Aucune donnée disponible', {value: ''})
		.subscribe((res: string) => this.empty_msgFr.emptyMessage = res);
	}

	ngOnInit(): void {
		this.getAllUsers();
	}

	//auto search after 500ms
	ngAfterViewInit(): void {
		fromEvent(this.search.nativeElement, 'keydown')
		.pipe(
			debounceTime(500),
			map(x => x['target']['value'])
		)
		.subscribe(value => {
			this.updateFilter(value);
		});

		this.fixBrowserTooltip();
	}

	getAllUsers(){
		this.blockUI.start('Loading');
		console.log("this.role", this.role);
		if (this.role === 'Provider'){
			this.usersService.getUserProviderSet(this.network).subscribe(
				(res) => {
				if (res.success){

					if (res.data.length === 0) {
						this.blockUI.stop();
						return
					};

					this.dataTableUser = res.data;
					this.collectionSize = res.data.length;
					this.rows = this.temp = this.dataTableUser;
					this.countDataLength = Object.keys(this.dataTableUser[0]).length;
					this.onPageChange();
					this.blockUI.stop();
				}
				else{
					this.blockUI.stop();
					if (res.errorSet.includes('ERROR_SERVER')) {
						this.toastrService.error('Une erreur serveur est survenue');
					}
				}
				},
				(error) => {
					this.blockUI.stop();
					this.toastrService.error('Une erreur s\'est produite');
				}
			);
		}
		else if (this.role === 'Shop'){
			this.usersService.getUserShopSet(this.network).subscribe(
				(res) => {

				if (res.success){

					if (res.data.length === 0) {
						this.blockUI.stop();
						return
					};

					this.dataTableUser = res.data;
					this.collectionSize = res.data.length;
					this.rows = this.temp = this.dataTableUser;
					// get the amount of columns in the table
					this.countDataLength = Object.keys(this.dataTableUser[0]).length;
					this.onPageChange();
					this.blockUI.stop();
				}
				else{
					this.blockUI.stop();
					if (res.errorSet.includes('ERROR_SERVER')) {
						this.toastrService.error('Une erreur serveur est survenue');
					}
				}
				},
				(error) => {
					this.blockUI.stop();
					this.toastrService.error('Une erreur s\'est produite');
				}
			);
		}
	}

	toggleFilter(){
		let tableFilter = document.getElementById("table-filter");
		tableFilter.style.display = (tableFilter.style.display === "none")?"block":"none";
	}

	onChangeFilter(e) {
		const filterProperties = e.value;
		switch (filterProperties){
		case "newest-date":
			this.dataTableUser = [...this.dataTableUser.sort((a,b) => b.lastConnect.localeCompare(a.lastConnect))];
			break;
		case "oldest-date":
			this.dataTableUser = [...this.dataTableUser.sort((a,b) => a.lastConnect.localeCompare(b.lastConnect))];
			break;
		case "asc-name":
			this.dataTableUser = [...this.dataTableUser.sort((a,b) => a.lastName.localeCompare(b.lastName))];
			break;
		case "desc-name":
			this.dataTableUser = [...this.dataTableUser.sort((a,b) => b.lastName.localeCompare(a.lastName))];
			break;
		}
		this.onPageChange();
	}

	editUserInfo(user: DataTableUser) {
		const modalRef = this.usersModalService.open(UserModificationComponent);
		modalRef.componentInstance.id = user.id;
		modalRef.componentInstance.role = this.role;
		modalRef.result.then((result) => {
			this.getAllUsers();
		// console.log(`Closed with: ${result}`);
		}, (reason) => {
			this.getAllUsers();
		// console.log(`Dismissed ${this.getDismissReason(reason)}`);
		});
	}

	editUserPayment(user: DataTableUser) {
		const modalRef = this.usersModalService.open(UserPaymentComponent);
		modalRef.componentInstance.id = user.id;
		modalRef.componentInstance.role = this.role;
		modalRef.result.then((result) => {
			this.getAllUsers();
		// console.log(`Closed with: ${result}`);
		}, (reason) => {
			this.getAllUsers();
		// console.log(`Dismissed ${this.getDismissReason(reason)}`);
		});
	}

	showUserInfo(user: DataTableUser){
		const modalRef = this.usersModalService.open(UserInfosComponent);
		modalRef.componentInstance.id = user.id;
		modalRef.componentInstance.role = this.role;
	}

	addUser(): void{
		const modalRef = this.usersModalService.open(UserCreationComponent);
		modalRef.componentInstance.role = this.role;
		modalRef.result.then((result) => {
			this.getAllUsers();
		}, (reason) => {
			this.getAllUsers();
		});
	}

	deleteUser(user: DataTableUser){
		this.blockUI.start('Loading');
		console.log("this.role", this.role, user);
		if (this.role !== 'Shop') {
			window.alert('Vous ne pouvez pas supprimer un fournisseur');
			return;
		}

		const data = {
			id: user.id,
			jwt: localStorage.getItem('token'),
			previousEmail: user.email,
		} as {id: string, jwt: string, forever?: boolean};

		this.usersService.deleteUserShop(data).subscribe(
			(res) => {
			if (res.success){
				this.toastrService.success('Mise à jour');
				this.getAllUsers();
				this.blockUI.stop();
			}
			else{
				this.blockUI.stop();
				if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
					this.toastrService.error('Les paramètres sont invalides');
				} else if (res.errorSet.includes('UNAUTHORIZED')){
					this.toastrService.error("L'accès non autorisé");
				} else if (res.errorSet.includes('NOTFOUND')){
					this.toastrService.error('Adhérent non trouvée');
				} else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
					this.toastrService.error('Une erreur serveur est survenue');
				}
			}
			},
			(error) => {
				this.blockUI.stop();
				// console.error(error);
				this.toastrService.error('Une erreur s\'est produite');
			}
		);
	}


	toggleUser(user: DataTableUser, forever: boolean = false){

		this.blockUI.start('Loading');

		const data = {
			id: user.id,
			jwt: localStorage.getItem('token')
		} as {id: string, jwt: string, forever?: boolean};
		if (forever) {
			data.forever = forever;
		}

		if (this.role === 'Provider'){
			this.usersService.toggleUserProvider(data).subscribe(
				(res) => {
				if (res.success){
					this.toastrService.success('Mise à jour');
					this.getAllUsers();
					this.blockUI.stop();
				}
				else{
					this.blockUI.stop();
					if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('UNAUTHORIZED')){
						this.toastrService.error("L'accès non autorisé");
					} else if (res.errorSet.includes('NOTFOUND')){
						this.toastrService.error('Fournisseur non trouvé');
					} else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
						this.toastrService.error('Une erreur serveur est survenue');
					}
				}
				},
				(error) => {
					this.blockUI.stop();
					// console.error(error);
					this.toastrService.error('Une erreur s\'est produite');
				}
			);
		} else if (this.role === 'Shop'){
			this.usersService.toggleUserShop(data).subscribe(
				(res) => {
				if (res.success){
					this.toastrService.success('Mise à jour');
					this.getAllUsers();
					this.blockUI.stop();
				}
				else{
					this.blockUI.stop();
					if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('UNAUTHORIZED')){
						this.toastrService.error("L'accès non autorisé");
					} else if (res.errorSet.includes('NOTFOUND')){
						this.toastrService.error('Adhérent non trouvée');
					} else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
						this.toastrService.error('Une erreur serveur est survenue');
					}
				}
				},
				(error) => {
					this.blockUI.stop();
					// console.error(error);
					this.toastrService.error('Une erreur s\'est produite');
				}
			);
		}
	}

	onSearchChange(value: any) {
		this.getAllUsers();
	}
	onPageChange(){
		this.dataTableUserDisplay = this.dataTableUser.slice((this.currentPage - 1) * this.pageSize, (this.currentPage - 1) * this.pageSize + this.pageSize)
	}

	resetSearch() {
		if (this.search.nativeElement.value) {
			this.getAllUsers();
			this.search.nativeElement.value = "";
		}
	}


	openHint(hint) {
		this.usersModalService.open(hint);
	}

	updateFilter(val: any) {
		this.currentPage = 1;
		const value = val.toString().toLowerCase().trim();
		// get the key names of each column in the dataset
		const keys = Object.keys(this.temp[0]);
		// assign filtered matches to the active datatable
		this.dataTableUser = this.temp.filter(item => {
			// iterate through each row's column data
			for (let i = 0; i < this.countDataLength; i++) {
				// check for a match
				if (
				(item[keys[i]] &&
					item[keys[i]]
					.toString()
					.toLowerCase()
					.indexOf(value) !== -1) ||
				!value
				) {
				// found match, return true to add to result set
				return true;
				}
			}
		});
		this.onPageChange();
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	fixBrowserTooltip(): void {
		let headerTitle = document.querySelectorAll('.datatable-header-cell');

		headerTitle.forEach(element => {

			let title = element.getAttribute('title');
			element.setAttribute('title', title.replace('<i class="fa fa-sort sort-icon"></i></span>', ''));

		});

	}
}
